import { FiltersMap, OptionalFiltersMap } from '@wix/bex-core';
import {
  useWixPatternsContainer,
  useWixPatternsContainerOverrides,
} from '@wix/bex-core/react';
import { useState } from 'react';
import { TableGridSwitchState } from '../state/TableGridSwitchState';
import { UseCollectionComponentBaseParams } from './useCollectionComponentBaseParams';

export interface UseTableGridSwitchParams<
  T,
  F extends FiltersMap = OptionalFiltersMap,
> extends UseCollectionComponentBaseParams<T, F> {}

export function useTableGridSwitch<
  T,
  F extends FiltersMap = OptionalFiltersMap,
>({ collection }: UseTableGridSwitchParams<T, F>) {
  const container = useWixPatternsContainer();
  const containerOverrides = useWixPatternsContainerOverrides();

  const [state] = useState(() => {
    return new TableGridSwitchState({
      collection,
      container,
      containerOverrides,
    });
  });

  return state;
}
